import { TimeoutError } from 'ky';

import type { IStandardErrorResponse } from 'src/api/common';

export const SEND_TIMEOUT_ERROR_MESSAGE =
    'The request timed out while sending the message. Please retry.';

/**
 * Derives a user-safe error message for a failed message send.
 * Only a backend-issued `.msg` (standard error response) is pre-vetted as
 * user-facing; network-level errors like ky's TimeoutError carry the raw
 * request method/URL in `.message` and must never be shown directly.
 */
export const getSendErrorMessage = (error: unknown, fallbackMessage: string): string => {
    if (error instanceof TimeoutError) {
        return SEND_TIMEOUT_ERROR_MESSAGE;
    }

    const standardError = error as Partial<IStandardErrorResponse> | undefined;

    const schemaValidationErrorMessages = standardError?.messages
        ?.map(o => o.msg)
        .filter((msg): msg is string => typeof msg === 'string' && msg.length > 0)
        .join(', ');

    if (schemaValidationErrorMessages) {
        return schemaValidationErrorMessages;
    }

    if (typeof standardError?.msg === 'string' && standardError.msg.length > 0) {
        return standardError.msg;
    }

    return fallbackMessage;
};
